import './style/bundle.scss';
import 'bootstrap';

/*
 * Require all components in the ./script/components folder
 */
let loadedComponents = {};

function importAll(r) {
    r.keys().forEach(key => loadedComponents[key] = r(key));

    // Ensure global is first component in the list
    const global = loadedComponents['./global.js'];
    delete loadedComponents['./global.js'];
    loadedComponents = {...{'./global.js': global}, ...loadedComponents};
}

importAll(require.context('./script/components/', true, /\.js$/));

window.app                   = window.app || {};
window.app.loadComponentsFor = function($container) {
    for (const [key, component] of Object.entries(loadedComponents)) {
        component.default($container);
    }
};

document.addEventListener('DOMContentLoaded', () => {
    window.app.loadComponentsFor($('body').removeClass('preload'));
});

